import assetClassificationActions from "../../../actions/assetClassificationActions";
import assetClassificationInputFields from "./assetClassificationInputFields";
import generateEntityEditor from "../../../hocs/generateEntityEditor";

const AssetClassificationEditor = generateEntityEditor({
  entitySingularString: "assetClassification",
  entityPluralString: "assetClassifications",
  entityActions: assetClassificationActions,
  returnRoutePath: "/asset-classifications-listing",
  fields: assetClassificationInputFields,
});

export default AssetClassificationEditor;
